import Watermark from './watermark';
export { watermarkProps } from './watermark';
/* istanbul ignore next */
Watermark.install = function (app) {
    app.component(Watermark.name, Watermark);
    return app;
};
export default Watermark;
